import * as actionType from "../constants/action_types";
const initialState = {
  list: [],
  details: null,
  migration_regions: [],
  migration_default_object: [],
  migration_status_list: [],
  migration_validation_result: [],
  migration_start_result:{},
  migration_api_validation_result:{}
};

const migrationReducer = (state = initialState, action) => {
  switch (action.type) {
    // GET responses start

    case actionType.GETMIGRATION_RESPONSE:
      return { ...state, list: action.payload };

    case actionType.GETMIGRATIONDETAILS_RESPONSE:
      return { ...state, details: action.payload };

    case actionType.GETOPPOSITEENVREGION_RESPONSE:
      return { ...state, migration_regions: action.payload };

    case actionType.GETMIGRATIONDEFAULTOBJECT_RESPONSE:
      return { ...state, migration_default_object: action.payload };

    case actionType.GETMIGRATIONOBJECTVALIDATE_RESPONSE:
      return { ...state, migration_validation_result: action.payload };

    case actionType.GETMIGRATIONSTATUSLIST_RESPONSE:
      return { ...state, migration_status_list: action.payload };

      case actionType.GETMIGRATIONSTART_RESPONSE:
        return { ...state, migration_start_result: action.payload };

        case actionType.APIKEYVALIDATION_RESPONSE:
          return { ...state, migration_api_validation_result: action.payload };

    default:
      return state;
  }
};

export { migrationReducer };
